<template>
    <div>
        <div class="text-center">{{'请确认账单金额USD ' + params.totalCost + '是否准确？'}}</div>
        <Form v-if="handleAuth('fbb.cost.supply')" class="margin-top-15" :label-width="80" ref="validForm" :model="formData" :rules="rules">
            <Col span="24">
                <FormItem label="供应商" prop="supplierId">
                    <Select v-model="formData.supplierId" clearable filterable>
                        <Option
                            v-for="item in supplierList"
                            :key="item.id"
                            :value="item.value"
                            >{{ item.label }}</Option
                        >
                    </Select>
                </FormItem>
            </Col>
        </Form>

        <div class="text-right margin-top-10">
            <vButton theme="primary" @click="submit">{{$t('global.datepicker.confirm', { defaultValue: '确认' })}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: "取消" })}}</vButton>
        </div>
    </div>
</template>

<script>
import { HttpConfirmBillSummary, HttpConfirmExpressFee} from '@/service/chargescalc';
import { mapGetters } from 'vuex';
import mixin from "../mixin";

export default {
    props: ['params'],
    mixins: [ mixin ],
    data(){
        return{
            formData: {},
            currentOrg: global.SYSID,
            rules: {
                supplierId: [
                    {
                        required: true,
                        message: "该项不能为空，请填写",
                    },
                ],
            }
        }
    },
    computed:{
        ...mapGetters('dictionary', []),
    },
    methods:{
        async submit(){
            if(this.currentOrg == '1000030'){
                let flag = true;
                await this.$refs.validForm.validate((valid) => {
                    flag = valid;
                });
                if (!flag) return;
            }
            this.params.type == 'billsummary' ?
            HttpConfirmBillSummary({
                id: this.params.id,
                supplierId: this.formData.supplierId
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.$emit('on-update')
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message)
            }) :
            HttpConfirmExpressFee({
                id: this.params.id,
                supplierId: this.formData.supplierId
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.$emit('on-update')
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message)
            })
        },
        cancel(){
            this.$emit('on-close')
        },
    },
}
</script>

